import React from "react";
import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    backgroundColor: "white",
  },
  section: {
    margin: 10,
    padding: 20,
    flexGrow: 1,
  },
  title: {
    fontSize: 24,
    marginBottom: 10,
    textAlign: "center",
  },
  text: {
    font: "times new roman",
    fontSize: 14,
    marginBottom: 5,
    fontWeight: "bold",
    textAlign: "center",
  },

  text1: {
    font: "times new roman",
    fontSize: 12,
    marginTop: 20,
  },
  text2: {
    font: "times new roman",
    fontSize: 12,
    marginTop: 5,
  },
  text3: {
    font: "times new roman",
    fontSize: 12,
    marginTop: 5,
    textDecoration: "underline",
  },
  text4: {
    font: "times new roman",
    fontSize: 12,
    marginTop: 20,
    fontWeight: "bolder",
  },

  text5: {
    fontWeight: "bold",
    textAlign: "center",
    font: "times new roman",
    fontSize: 12,
    marginTop: 20,
  },
  text6: {
    fontWeight: "bold",
    textAlign: "left",
    fontSize: 12,
    marginTop: 20,
  },
  text7: {
    fontWeight: "bold",
    marginLeft: 100,
    fontSize: 12,
  },
});

function OrderMissionContract(props) {
  console.log("props in OrderMissionContract:", props?.missionDetail);
  const missionDetail = props?.missionDetail;
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          <Text style={styles.text}>ORDRE DE MISSION</Text>
          <Text style={styles.text1}> [Coordonnées de l'entreprise]</Text>
          <Text style={styles.text2}>Objet : ordre de mission</Text>
          {/* <Text style={styles.text2}> */}
          Par la présente, l'entreprise IWARE confie à son collaborateur{" "}
          {missionDetail
            ? missionDetail.firstname + " " + missionDetail.lastname
            : ""}
          {/* , résidant au {missionDetail ? missionDetail.adr : ""}{" "}
            {missionDetail ? missionDetail.country : ""} et agissant en tant que{" "}
            {missionDetail ? missionDetail.nomPost : ""}, la mission de{" "}
            {missionDetail ? missionDetail.intitule : ""}.
          </Text>
          <Text style={styles.text4}>
            Cette mission a pour but de{" "}
            {missionDetail ? missionDetail.intitule : ""} et aura lieu du{" "}
            {missionDetail ? missionDetail.dateDeb : ""} au{" "}
            {missionDetail ? missionDetail.dateFin : ""}.
          </Text>

          <Text style={styles.text4}>
            Le déplacement du salarié aura lieu entre son lieu de résidence,
            {missionDetail ? missionDetail.villeDept : ""}, et le lieu de sa
            mission, situé au {missionDetail ? missionDetail.villeDest : ""}{" "}
            {missionDetail ? missionDetail.paysDest : ""}.
          </Text>
          <Text style={styles.text4}>
            Pour son voyage aller-retour, le salarié utilisera les accusations
            suivantes :<br />
            {missionDetail &&
            missionDetail.charges &&
            missionDetail.charges.length > 0 ? (
              <>
                {missionDetail.charges.map((charge, index) => (
                  <>
                    <React.Fragment key={index}>
                      -{charge.nomCharge}
                      <br />-{charge.frais} dt
                      <br />
                    </React.Fragment>
                  </>
                ))}
              </>
            ) : (
              "Aucune accusation disponible."
            )}
          </Text>
          <Text style={styles.text4}>
            Les frais de déplacement seront intégralement remboursés par [nom de
            l'entreprise], sous réserve de présentation desdites factures et de
            leur conformité à la politique interne de [nom de l'entreprise].
          </Text>

          <Text style={styles.text4}>
            {" "}
            Monsieur Mohamed ben Mohamed déclare formellement n’être lié à
            aucune autre entreprise, être libre de tout engagement. En outre,
            Monsieur Mohamed ben Mohamed s’engage à faire connaître, sans délai,
            tout changement qui interviendrait dans sa situation, concernant son
            adresse, situation familiale…
          </Text>

          <Text style={styles.text5}>Fait à Sousse le ..../../.. ,</Text>
          <Text style={styles.text4}>
            <Text style={styles.text6}>Signature et cachet </Text>
          </Text> */}
        </View>
      </Page>
    </Document>
    // <></>
  );
}

export default OrderMissionContract;
